export default __webpack_public_path__ + "static/media/TheWorldEngland_04.4890b3a5.png";